import { chakra, Flex, HStack } from '@chakra-ui/react';
import React, { ReactNode } from 'react';

type HeroButtonsProps = {
  children: ReactNode;
  className?: string;
};

/**
 * Hero Buttons component
 */
export default chakra(function HeroButtons({
  children,
  className,
}: HeroButtonsProps) {
  return (
    <Flex
      className={className}
      mt='36px'
      justifyContent={{ lg: 'flex-start', base: 'center' }}
    >
      <HStack spacing='20px'>{children}</HStack>
    </Flex>
  );
});
